import React, { useState, useEffect } from 'react';
import { Card, Input, Button, Typography, List, Spin, message } from 'antd';
import { BulbOutlined, CodeOutlined } from '@ant-design/icons';
import ReactMarkdown from 'react-markdown';
import { socket } from '../socket';

const { TextArea } = Input;
const { Title, Text, Paragraph } = Typography;

function AIAssistant({ storyName, storyDescription, onClose, onUpdateDescription, storyId }) {
  const [loading, setLoading] = useState(false);
  const [acceptanceCriteria, setAcceptanceCriteria] = useState(null);
  const [technicalSteps, setTechnicalSteps] = useState(null);

  const appendToDescription = (content, type) => {
    const separator = "\n\n";
    const header = `## ${type}\n`;
    const newDescription = storyDescription 
      ? `${storyDescription}${separator}${header}${content}`
      : `${header}${content}`;
    
    onUpdateDescription(storyId, newDescription);
  };

  useEffect(() => {
    const handleAIResponse = ({ type, content }) => {
      if (type === 'acceptance') {
        setAcceptanceCriteria(content);
        appendToDescription(content, 'Acceptance Criteria');
      } else {
        setTechnicalSteps(content);
        appendToDescription(content, 'Technical Steps');
      }
      setLoading(false);
    };

    const handleAIError = ({ message: errorMessage }) => {
      message.error(errorMessage);
      setLoading(false);
    };

    socket.on('aiResponse', handleAIResponse);
    socket.on('aiError', handleAIError);

    return () => {
      socket.off('aiResponse', handleAIResponse);
      socket.off('aiError', handleAIError);
    };
  }, [storyId, storyDescription, onUpdateDescription]);

  const generateAcceptanceCriteria = () => {
    setLoading(true);
    socket.emit('generateAI', { 
      storyName,
      storyDescription, 
      type: 'acceptance' 
    });
  };

  const generateTechnicalSteps = () => {
    setLoading(true);
    socket.emit('generateAI', { 
      storyName,
      storyDescription, 
      type: 'technical' 
    });
  };

  return (
    <Card title="AI Assistant" extra={<Button onClick={onClose}>Close</Button>}>
      <div style={{ marginBottom: 16 }}>
        <Text strong>Story:</Text>
        <Title level={4} style={{ margin: '8px 0' }}>{storyName}</Title>
        
        <Text strong>Description:</Text>
        <div className="markdown-content" style={{ marginTop: 8 }}>
          <ReactMarkdown>
            {storyDescription || 'No description provided'}
          </ReactMarkdown>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
        <Button
          type="primary"
          icon={<BulbOutlined />}
          onClick={generateAcceptanceCriteria}
          loading={loading}
        >
          Generate Acceptance Criteria
        </Button>
        <Button
          type="primary"
          icon={<CodeOutlined />}
          onClick={generateTechnicalSteps}
          loading={loading}
        >
          Generate Technical Steps
        </Button>
      </div>

      {acceptanceCriteria && (
        <div style={{ marginBottom: 16 }}>
          <Title level={4}>Acceptance Criteria</Title>
          <div className="markdown-content">
            <ReactMarkdown>{acceptanceCriteria}</ReactMarkdown>
          </div>
        </div>
      )}

      {technicalSteps && (
        <div>
          <Title level={4}>Technical Steps</Title>
          <div className="markdown-content">
            <ReactMarkdown>{technicalSteps}</ReactMarkdown>
          </div>
        </div>
      )}
    </Card>
  );
}

export default AIAssistant; 